import PremiumDueTable from 'components/features/premium-due-table';

const FinanceDashboard = () => {
  return <PremiumDueTable />;
};

export default FinanceDashboard;
